import { TagTheme } from '@/components/Tag/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Tag = GenericSlot({ as: 'span', theme: TagTheme });
export const ListTag = GenericSlot({ as: 'li', theme: TagTheme });
